import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box overflow sendSetting" }
const _hoisted_2 = { class: "settingBlockContainer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "1일 폰발송 제한 건수", -1)
const _hoisted_4 = { class: "settingBlockArea" }
const _hoisted_5 = { class: "settingBlock left poRel" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockText left" }, "1일 폰발송 가능 건수", -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<option value=\"50\">450건</option><option value=\"100\">400건</option><option value=\"150\">350건</option><option value=\"200\">300건</option><option value=\"300\">200건</option><option value=\"350\">150건</option><option value=\"400\">100건</option>", 7)
const _hoisted_14 = [
  _hoisted_7
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockword left mgL15" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "1일 폰발송 가능건수 = 하루에 최대 발송가능한 건수입니다. "),
    /*#__PURE__*/_createElementVNode("li", null, "SMS/LMS/MMS모두 1건으로 계산됩니다.")
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"settingBlockArea\"><div class=\"settingBlock left\"><div class=\"settingBlockText left\">통신사별 발송량 제한 정책 확인</div><button class=\"whiteBtn right\"> 확인</button></div><div class=\"settingBlockword left mgL15\"><ul><li>통신사의 정책에 따라 하루 최대 500건을 초과하거나 일 200건 이상 월 10회 이상 폰발송시<br>스마트폰의 발송이 차단되거나 과금될 수 있으니 주의하시기 바랍니다. </li></ul></div></div>", 1)
const _hoisted_17 = { class: "settingBlockContainer" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "장문 메시지 제목 입력란 사용", -1)
const _hoisted_19 = { class: "settingBlockArea" }
const _hoisted_20 = { class: "settingBlock left poRel" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockText left" }, "제목 입력란 사용", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockword left mgL15" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("장문 메시지 (멀티미디어 메시지) 발송시 제목 입력란을 사용합니다. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("제목을 입력하지 않고 발송시 메시지 본문의 시작부분 15자가 제목으로 설정됩니다. ")
    ])
  ])
], -1)
const _hoisted_23 = { class: "settingBlockContainer" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "로밍시 폰발송 차단", -1)
const _hoisted_25 = { class: "settingBlockArea" }
const _hoisted_26 = { class: "settingBlock left poRel" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockText left" }, "로밍시 폰발송 차단여부", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockword left mgL15" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("해외 출국 시 폰발송으로 문자 등이 발송되는 경우 로밍 문자 요금이 발생하므로"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("휴대폰이 로밍상태일 때는 폰발송을 차단합니다. ")
    ])
  ])
], -1)
const _hoisted_29 = { class: "conBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            class: "selectBox right",
            style: {"margin-right":"0"},
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.api.SMT_BALA_CNT) = $event))
          }, _hoisted_14, 512), [
            [_vModelSelect, $data.api.SMT_BALA_CNT]
          ])
        ]),
        _hoisted_15
      ]),
      _hoisted_16
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("button", {
            class: "blueBtn right",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.api.MMS_TITLE='0'))
          }, "사용", 512), [
            [_vShow, $data.api.MMS_TITLE == '1']
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "redBtn right",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.api.MMS_TITLE='1'))
          }, "사용안함", 512), [
            [_vShow, $data.api.MMS_TITLE == '0']
          ])
        ]),
        _hoisted_22
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createElementVNode("button", {
            class: "blueBtn right",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($data.api.SMT_ROAM_YN='N'))
          }, "로밍시 발송", 512), [
            [_vShow, $data.api.SMT_ROAM_YN == 'Y']
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "redBtn right",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($data.api.SMT_ROAM_YN='Y'))
          }, "로밍시 발송 차단", 512), [
            [_vShow, $data.api.SMT_ROAM_YN == 'N']
          ])
        ]),
        _hoisted_28
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("button", {
        class: "grayBtn",
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.getConfList()))
      }, " 취소 "),
      _createTextVNode("   "),
      _createElementVNode("button", {
        class: "blueBtn",
        onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.conf_save()))
      }, " 저장 ")
    ])
  ]))
}